import { render, staticRenderFns } from "./ReconciliationStep5.vue?vue&type=template&id=264f2530&scoped=true&"
import script from "./ReconciliationStep5.vue?vue&type=script&lang=js&"
export * from "./ReconciliationStep5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264f2530",
  null
  
)

export default component.exports